import { BASE_URL, CURRENCY_CODE } from '../config';

export async function paymentIntent(totalPrice, cart) {
    const accessToken = localStorage.getItem('accessToken');
    console.log(cart);
    try {
        const response = await fetch(BASE_URL + '/products/payment', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...(accessToken ? { 'Authorization': `Bearer ${accessToken}` } : {})
            },
            body: JSON.stringify({ amount: totalPrice, currency: CURRENCY_CODE, cart: cart, })
        });        

        console.log("what");

        const responseBody = await response.json();
        console.log(response);
        console.log(responseBody);

        if (response.status === 200) {
            return responseBody;  // Successful purchase response, containing details like clientSecret
        } else {
            throw new Error(responseBody.detail || 'Failed to complete purchase');
        }


    } catch (error) {
        console.error("Error: " + error);
    }
}

export async function buy(totalPrice, items, paymentMethodId, customerInfo, shippingPaid, coupon, user) {
    const accessToken = localStorage.getItem('accessToken');
    console.log(accessToken);
    try {
        const response = await fetch(BASE_URL + '/products/buy', {
            method: 'POST',
            headers: {
                ...(accessToken && { 'Authorization': `Bearer ${accessToken}` }),
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                payment_method_id: paymentMethodId,  // Payment method ID from the frontend
                shipping_paid: shippingPaid,
                total_price: totalPrice,  // Total price of the purchase
                currency: CURRENCY_CODE,
                code: coupon,
                user: user,
                cart: items.map(item => ({
                    id: item.id,          // Product ID of the purchased item
                    count: item.count // Quantity of the purchased item
                })),
                customer_info: {  // Add customer info to the request body
                    tiktok_name: customerInfo.tiktokName,
                    first_name: customerInfo.firstName,
                    last_name: customerInfo.lastName,
                    address: customerInfo.address,
                    city: customerInfo.city,
                    postcode: customerInfo.postcode,
                    state: customerInfo.state
                },
            }),
        });

        const responseBody = await response.json();
        console.log(response);
        console.log(responseBody);

        if (response.status === 200) {
            return responseBody;  // Successful purchase response, containing details like clientSecret
        } else {
            throw new Error(responseBody.detail || 'Failed to complete purchase');
        }

    } catch (error) {
        console.error(error.message);
        throw new Error(error.message);
    }
}

export async function applyCoupon(coupon, cart) {
    const accessToken = localStorage.getItem('accessToken');

    try {
        const response = await fetch(BASE_URL + "/coupon/apply", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...(accessToken && { 'Authorization': `Bearer ${accessToken}` }),

            },
            body: JSON.stringify({
                code: coupon,
                cart: cart,
            })
        })

        if (response.ok) {
            const data = await response.json();
            return {
                success: true,
                data: data,
                message: "Coupon " + coupon + " applied successfully.",
            };
        } else {
            return {
                success: false,
                data: {coupon: null},
                message: "The coupon you provided is not valid.",
            };
        }
    } catch (error) {
        return {
            success: false,
            data: {coupon:null},
            message: "An error occurred while applying the coupon.",
            error: error.message,
        };
    }
}

export async function generatePayID(totalPrice, items, customerInfo, shippingPaid, coupon, user) {
    const accessToken = localStorage.getItem('accessToken');
    console.log(coupon);
    try {
        const response = await fetch(BASE_URL + '/products/buy', {
            method: 'POST',
            headers: {
                ...(accessToken && { 'Authorization': `Bearer ${accessToken}` }),
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                payment_method_id: "PAYID",  // Payment method ID from the frontend
                shipping_paid: shippingPaid,
                total_price: totalPrice,  // Total price of the purchase
                currency: CURRENCY_CODE,
                user: user,
                code: coupon,
                cart: items.map(item => ({
                    id: item.id,          // Product ID of the purchased item
                    count: item.count // Quantity of the purchased item
                })),
                customer_info: {  // Add customer info to the request body
                    tiktok_name: customerInfo.tiktokName,
                    first_name: customerInfo.firstName,
                    last_name: customerInfo.lastName,
                    address: customerInfo.address,
                    city: customerInfo.city,
                    postcode: customerInfo.postcode,
                    state: customerInfo.state
                },
            }),
        });

        const responseBody = await response.json();
        console.log(responseBody);

        if (response.status === 200) {
            return responseBody;  // Successful purchase response, containing details like clientSecret
        } else {
            throw new Error(responseBody.detail || 'Failed to complete purchase');
        }

    } catch (error) {
        console.error(error.message);
        throw new Error(error.message);
    }
}